import React from 'react';
import CustomerReportFunctional from './components/customer-report-list-functional';
import './customer-report.scss';

const CustomerReport = () => {
	return <CustomerReportFunctional />;
};

export default CustomerReport;
